"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const get_1 = __importDefault(require("lodash/get"));
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const react_i18next_1 = require("react-i18next");
const events_1 = __importDefault(require("events"));
const FullSizePanel_1 = __importDefault(require("chaire-lib-frontend/lib/components/dashboard/FullSizePanel"));
const pages_1 = require("chaire-lib-frontend/lib/components/pages");
const Toolbar_1 = __importDefault(require("chaire-lib-frontend/lib/components/dashboard/Toolbar"));
const SplitView_1 = __importDefault(require("chaire-lib-frontend/lib/components/dashboard/SplitView"));
const MenuBar_1 = __importDefault(require("chaire-lib-frontend/lib/components/dashboard/MenuBar"));
const RightPanel_1 = __importDefault(require("chaire-lib-frontend/lib/components/dashboard/RightPanel"));
const BottomPanel_1 = __importDefault(require("chaire-lib-frontend/lib/components/dashboard/BottomPanel"));
const EventManager_1 = __importDefault(require("chaire-lib-common/lib/services/events/EventManager"));
const KeyboardManager_1 = __importDefault(require("chaire-lib-frontend/lib/services/dashboard/KeyboardManager"));
const CollectionManager_1 = __importDefault(require("chaire-lib-common/lib/utils/objects/CollectionManager"));
const SelectedObjectsManager_1 = __importDefault(require("chaire-lib-frontend/lib/services/objects/SelectedObjectsManager"));
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const Notifications_1 = __importDefault(require("chaire-lib-common/lib/services/events/Notifications"));
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const ConfirmModal_1 = __importDefault(require("chaire-lib-frontend/lib/components/modal/ConfirmModal"));
const DataSourceCollection_1 = __importDefault(require("chaire-lib-common/lib/services/dataSource/DataSourceCollection"));
const ZoneGeojsonCollection_1 = __importDefault(require("octavi-common/lib/services/zones/ZoneGeojsonCollection"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const utils_1 = require("octavi-legacy/lib/services/ui/utils");
/**
 * FIXME Copied from the transition dashboard and adapted to Octavi from the
 * original OctaviDashboard
 */
class Dashboard extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            ServiceLocator_1.default.eventManager.emit('progress', { name: 'MapLoading', progress: 0.0 }); // this does not trigger notification in TopMenu because TopMenu is not yet mounted.
            ServiceLocator_1.default.eventManager.on('map.loaded', this.onMapLoaded);
            ServiceLocator_1.default.eventManager.on('fullSizePanel.show', this.onShowFullSizePanel);
            ServiceLocator_1.default.eventManager.on('fullSizePanel.hide', this.onHideFullSizePanel);
            ServiceLocator_1.default.eventManager.on('section.change', this.onChangeSection);
            document.addEventListener('keydown', this.handleKeyDown, false);
            document.addEventListener('keyup', this.handleKeyUp, false);
            this.socket = (0, socket_io_client_1.default)({
                transports: ['websocket'],
                // reconnection attempts, no limits, uses exponential backoff, starts at 1 second and eventually stops at every 2 minutes
                reconnectionDelayMax: 120000
            }).connect();
            this.socket.on('connect', this.socketConnectHandler);
            this.socket.on('disconnect', this.socketDisconnectHandler);
        };
        this.componentWillUnmount = () => {
            var _a, _b;
            ServiceLocator_1.default.eventManager.off('map.loaded', this.onMapLoaded);
            ServiceLocator_1.default.eventManager.off('fullSizePanel.show', this.onShowFullSizePanel);
            ServiceLocator_1.default.eventManager.off('fullSizePanel.hide', this.onHideFullSizePanel);
            ServiceLocator_1.default.eventManager.off('section.change', this.onChangeSection);
            document.removeEventListener('keydown', this.handleKeyDown, false);
            document.removeEventListener('keyup', this.handleKeyUp, false);
            (_a = this.socket) === null || _a === void 0 ? void 0 : _a.off('connect', this.socketConnectHandler);
            (_b = this.socket) === null || _b === void 0 ? void 0 : _b.off('disconnect', this.socketDisconnectHandler);
        };
        this.handleKeyDown = (e) => {
            ServiceLocator_1.default.keyboardManager.keyDown(e);
        };
        this.handleKeyUp = (e) => {
            ServiceLocator_1.default.keyboardManager.keyUp(e);
        };
        this.onShowFullSizePanel = () => {
            this.setState({ showFullSizePanel: true });
        };
        this.onHideFullSizePanel = () => {
            this.setState({ showFullSizePanel: false });
        };
        this.onChangeSection = (section, fullSizePanel) => {
            // Verify if there are unsaved changes
            const selectedObjectsByType = ServiceLocator_1.default.selectedObjectsManager.getSelections();
            const selectedObjects = Object.values(selectedObjectsByType).flatMap((objects) => objects);
            const selectedObjectsWithChanges = selectedObjects.some((object) => {
                // TODO: update the any type with typeguard
                if (object &&
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    object.hasChanged &&
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    typeof object === 'function' &&
                    object.hasChanged()) {
                    return true;
                }
                return false;
            });
            if (selectedObjectsWithChanges) {
                this.setState({ unsavedChangesModalIsOpen: true });
            }
            else {
                ServiceLocator_1.default.selectedObjectsManager.deselectAll();
                ServiceLocator_1.default.eventManager.emit('map.handleDrawControl', section);
                /*serviceLocator.eventManager.emit(
                    'map.updateEnabledLayers',
                    sectionLayers[section] // will be undefined if section has no layers
                ); */
                this.setState({ activeSection: section, showFullSizePanel: fullSizePanel });
            }
        };
        this.onPreferencesChange = () => {
            const infoPanelPosition = Preferences_1.default.get('infoPanelPosition');
            this.setState({ infoPanelPosition });
        };
        this.socketConnectHandler = () => {
            console.log('SOCKET: connected to socket');
            const socketWasConnected = this.state.socketWasConnected;
            // FIXME fix the any type, the Socket type is fine for the EventManager's usage, but it receives an EventEmitter and some functions are missing in the socket
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ServiceLocator_1.default.addService('socketEventManager', new EventManager_1.default(this.socket));
            ServiceLocator_1.default.notificationService.registerEventsOnEmitter(ServiceLocator_1.default.socketEventManager);
            if (socketWasConnected) {
                this.setState({ socketConnected: true });
            }
            else {
                // firsty load the preferences, then set socket state to connected, so the main map can get preferences on first load.
                Preferences_1.default.load(ServiceLocator_1.default.socketEventManager).then(() => {
                    this.setState({
                        preferencesLoaded: true,
                        socketConnected: true,
                        socketWasConnected: true,
                        // FIXME Support default section in octavi?
                        // activeSection: Preferences.attributes.defaultSection,
                        infoPanelPosition: Preferences_1.default.attributes.infoPanelPosition
                    });
                });
            }
            // Get available osrm routing modes from server:
            ServiceLocator_1.default.socketEventManager.emit('service.osrmRouting.availableRoutingModes', (availableRoutingModes) => {
                this.setState({
                    availableRoutingModes
                });
            });
        };
        this.socketDisconnectHandler = () => {
            console.log('SOCKET: disconnected from socket');
            ServiceLocator_1.default.notificationService.deregisterEventsOnEmitter(ServiceLocator_1.default.socketEventManager);
            this.setState({ socketConnected: false });
        };
        // FIXME The only collection we need is the data source. Let's see after some refactoring
        this.loadLayersAndCollections = () => __awaiter(this, void 0, void 0, function* () {
            const dataSourceCollection = new DataSourceCollection_1.default([], {}, ServiceLocator_1.default.eventManager);
            // Load dataSourceCollection
            yield dataSourceCollection.loadFromServer(ServiceLocator_1.default.socketEventManager, ServiceLocator_1.default.collectionManager);
            ServiceLocator_1.default.collectionManager.add('dataSources', dataSourceCollection);
            // Get the zones for the data source of the right type
            const zoneGeojsonCollection = new ZoneGeojsonCollection_1.default([], {}, ServiceLocator_1.default.eventManager);
            const zonesDs = dataSourceCollection.features.find((ds) => ds.attributes.type === 'zones');
            if (zonesDs !== undefined) {
                yield zoneGeojsonCollection.loadFromServer(ServiceLocator_1.default.socketEventManager, zonesDs.getId());
                ServiceLocator_1.default.collectionManager.add('zones', zoneGeojsonCollection);
                //create zone agregation
                ServiceLocator_1.default.eventManager.emit('progress', { name: 'OctaviMakingSpationAggrgegation', progress: 0.0 });
                const aggregations = Preferences_1.default.get('spatialAggregations');
                const aggregatedZones = {};
                if (!(0, LodashExtensions_1._isBlank)(aggregations)) {
                    for (const aggregation of aggregations) {
                        aggregatedZones[`data_lvl${aggregation.level}`] = (0, utils_1.featureAggregator)(aggregation, zoneGeojsonCollection);
                    }
                }
                ServiceLocator_1.default.collectionManager.add('aggregatedZones', aggregatedZones);
                ServiceLocator_1.default.eventManager.emit('progress', { name: 'OctaviMakingSpationAggrgegation', progress: 1.0 });
                ServiceLocator_1.default.eventManager.emit('taxi.filter.spatial.enable');
            }
        });
        this.onMapLoaded = () => {
            ServiceLocator_1.default.eventManager.emit('progress', { name: 'MapLoading', progress: 1.0 });
            this.loadLayersAndCollections();
        };
        this.closeUnsavedChangesModal = (e) => {
            if (e && typeof e.stopPropagation === 'function') {
                e.stopPropagation();
            }
            this.setState({
                unsavedChangesModalIsOpen: false
            });
        };
        // FIXME Hard-coded section. It should be taken from preferences and we should define the sections somewhere too
        const activeSection = 'octaviHighlights';
        this.state = {
            preferencesLoaded: false,
            socketConnected: false,
            socketWasConnected: false,
            showFullSizePanel: true,
            activeSection,
            infoPanelPosition: 'right',
            unsavedChangesModalIsOpen: false,
            availableRoutingModes: []
        };
        ServiceLocator_1.default.addService('eventManager', new EventManager_1.default(new events_1.default()));
        ServiceLocator_1.default.addService('collectionManager', new CollectionManager_1.default(ServiceLocator_1.default.eventManager));
        ServiceLocator_1.default.addService('selectedObjectsManager', new SelectedObjectsManager_1.default(ServiceLocator_1.default.eventManager));
        ServiceLocator_1.default.addService('keyboardManager', KeyboardManager_1.default);
        ServiceLocator_1.default.addService('notificationService', new Notifications_1.default());
        ServiceLocator_1.default.eventManager.emit('progress', { name: 'MapLoading', progress: 0.0 });
        Preferences_1.default.addChangeListener(this.onPreferencesChange);
        const allLayoutContribs = props.contributions.flatMap((contrib) => contrib.getLayoutContributions());
        this.contributions = {
            bottomPanel: allLayoutContribs.filter((contrib) => contrib.placement === 'bottomPanel'),
            menuBar: allLayoutContribs.filter((contrib) => contrib.placement === 'menu'),
            toolbar: allLayoutContribs.filter((contrib) => contrib.placement === 'toolbar'),
            fullSize: allLayoutContribs.filter((contrib) => contrib.placement === 'mapOverlay'),
            rightPanel: allLayoutContribs.filter((contrib) => contrib.placement === 'primarySidebar')
        };
    }
    render() {
        if (!this.state.preferencesLoaded || (!this.state.socketConnected && !this.state.socketWasConnected)) {
            return react_1.default.createElement(pages_1.LoadingPage, null);
        }
        const preferencesMapCenter = (0, get_1.default)(Preferences_1.default.current, 'map.center', null);
        const mapCenter = preferencesMapCenter;
        const preferencesMapZoom = (0, get_1.default)(Preferences_1.default.current, 'map.zoom', null);
        const mapZoom = preferencesMapZoom || 10;
        const Map = this.props.mainMap;
        const mapComponent = (react_1.default.createElement(Map, { center: mapCenter, zoom: mapZoom, activeSection: this.state.activeSection }, this.state.showFullSizePanel && (react_1.default.createElement(FullSizePanel_1.default, { activeSection: this.state.activeSection, contributions: this.contributions.fullSize }))));
        const infoPanelComponent = (react_1.default.createElement(RightPanel_1.default, { activeSection: this.state.activeSection, contributions: this.contributions.rightPanel, availableRoutingModes: this.state.availableRoutingModes }));
        return (react_1.default.createElement(react_1.default.Fragment, null,
            !this.state.socketConnected && this.state.socketWasConnected && (react_1.default.createElement("div", { className: "_container _center _full-width" },
                react_1.default.createElement("p", { className: "_error" }, this.props.t('main:connectionIsOffline')))),
            react_1.default.createElement("section", { id: "tr__dashboard", className: !this.state.socketConnected && this.state.socketWasConnected ? '_hide' : '' },
                react_1.default.createElement(Toolbar_1.default, { activeSection: this.state.activeSection, contributions: this.contributions.toolbar }),
                react_1.default.createElement("div", { id: "tr__main-container" },
                    react_1.default.createElement(MenuBar_1.default, { activeSection: this.state.activeSection, contributions: this.contributions.menuBar }),
                    react_1.default.createElement(SplitView_1.default, { minLeftWidth: this.state.infoPanelPosition === 'left' ? 500 : 150, initialLeftWidth: this.state.infoPanelPosition !== 'left' ? '65%' : '35%', leftViewID: this.state.infoPanelPosition, hideRightViewWhenResizing: this.state.infoPanelPosition === 'left', hideLeftViewWhenResizing: this.state.infoPanelPosition !== 'left', right: this.state.infoPanelPosition !== 'left' ? infoPanelComponent : mapComponent, left: this.state.infoPanelPosition === 'left' ? infoPanelComponent : mapComponent }),
                    this.state.unsavedChangesModalIsOpen && (react_1.default.createElement(ConfirmModal_1.default, { isOpen: true, title: this.props.t('main:UnsavedChanges'), closeModal: this.closeUnsavedChangesModal, confirmButtonColor: "grey", confirmButtonLabel: this.props.t('main:OK'), showCancelButton: false }))),
                react_1.default.createElement(BottomPanel_1.default, { activeSection: this.state.activeSection, contributions: this.contributions.bottomPanel })),
            react_1.default.createElement("footer", null,
                react_1.default.createElement("ul", { className: "_pale" },
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: "https://github.com/chairemobilite/octavi/" }, "Github"))))));
    }
}
exports.default = (0, react_i18next_1.withTranslation)(['main', 'form', 'menu', 'od', 'octavi', 'notifications', 'variables'])(Dashboard);
//# sourceMappingURL=OctaviDashboard.js.map